export function last(array) { return array[array.length - 1]; }
export function shuffle(_array) {
  const array = _array.slice();
  const lastIndex = array.length - 1;

  array.forEach((_, index) => {
    const randomIndex = index + Math.floor(Math.random() * (lastIndex - index + 1));
    const currentValue = array[index];

    array[index] = array[randomIndex];
    array[randomIndex] = currentValue;
  });

  return array;
}
export function times(length) { return Array(length).fill().map((_, index) => index); }
export function unique(array) { return array.filter((x, index) => array.indexOf(x) === index); }
